(function () {
	"use strict";

	// URL parameter utilities
	function getUrlParameter(name) {
		const url = new URL(window.location);
		return url.searchParams.get(name);
	}

	function updateUrlParameter(name, value) {
		const url = new URL(window.location);
		if (value) {
			url.searchParams.set(name, value);
		} else {
			url.searchParams.delete(name);
		}
		window.history.replaceState({}, "", url);
	}

	// Shared price calculation utility
	function calculatePriceWithQuantity(basePrice, quantity = 1) {
		if (quantity <= 1) {
			return basePrice;
		}

		const priceMatch = basePrice.match(/[\d,]+\.?\d*/);
		if (!priceMatch) {
			return basePrice;
		}

		const unitPrice = parseFloat(priceMatch[0].replace(/,/g, ""));
		const totalPrice = unitPrice * quantity;
		const currencySymbol = basePrice.replace(/[\d,.\s]/g, "");
		return currencySymbol + totalPrice.toFixed(2);
	}

	// Get current quantity from quantity input
	function getCurrentQuantity() {
		const quantityInput = document.querySelector(".qty.quantity__input");
		return quantityInput ? parseInt(quantityInput.value) || 1 : 1;
	}

	// Handle non-widget price updates
	function initNonWidgetPriceUpdate() {
		const buttonPrice = document.querySelector(".pdp-atc-price .price .amount");
		const oneTimePrice = document.querySelector("[pdp-atc-price]")?.getAttribute("one-time-price");
		const quantityInput = document.querySelector(".qty.quantity__input");

		if (!buttonPrice || !oneTimePrice || !quantityInput) return;

		quantityInput.addEventListener("change", () => {
			const quantity = getCurrentQuantity();
			const formattedPrice = calculatePriceWithQuantity(oneTimePrice, quantity);
			buttonPrice.innerHTML = formattedPrice;
		});
	}

	function initModernAppstleWidget() {
		const widget = document.querySelector(".appstle_sub_widget_modern");
		if (!widget) {
			initNonWidgetPriceUpdate();
			return;
		}

		const optionWrappers = widget.querySelectorAll(".appstle_option_wrapper");
		const radioButtons = widget.querySelectorAll('input[name="selling_plan"]');
		const hiddenInput = widget.querySelector(".appstle-selectedSellingPlan");
		const frequencyRadios = widget.querySelectorAll(".appstle_frequency_radio");
		const productForm = document.querySelector("form[data-type='add-to-cart-form']");
		const buttonPrice = productForm.querySelector(".product-price-container");
		const buttonPriceOneTime = buttonPrice.dataset.onetimePrice;
		const buttonPriceSubscription = buttonPrice.dataset.subscriptionPrice;

		// Function to update price based on current quantity and selection
		function updatePriceForQuantity() {
			const selectedRadio = widget.querySelector('input[name="selling_plan"]:checked');
			if (!selectedRadio || !buttonPrice) return;

			const isSubscription = selectedRadio.value !== "";
			const basePrice = isSubscription ? buttonPriceSubscription : buttonPriceOneTime;
			const quantity = getCurrentQuantity();
			const formattedPrice = calculatePriceWithQuantity(basePrice, quantity);
			buttonPrice.innerHTML = formattedPrice;
		}

		// Handle option selection - updates styles/classes
		function handleOptionSelection(selectedWrapper, selectedRadio) {
			// Remove active class from all wrappers
			optionWrappers.forEach((wrapper) => {
				wrapper.classList.remove("appstle-active-option");
			});

			// Add active class to selected wrapper
			selectedWrapper.classList.add("appstle-active-option");

			// Update hidden input value
			if (hiddenInput) {
				hiddenInput.value = selectedRadio.value;
			}

			// Update widget data attribute
			widget.setAttribute("data-selected-selling-plan", selectedRadio.value);

			// Show/hide elements based on selection
			const frequencyWrapper = widget.querySelector(".appstle_frequency_wrapper");
			const benefitsWrapper = widget.querySelector(".appstle_benefits_wrapper");
			const subscriptionWrapper = widget.querySelector(".appstle_subscription_option");
			const subscriptionContent = widget.querySelector(".appstle_subscription_content");
			const quantitySelector = document.querySelector("quantity-selector.quantity");
			const savingBadgeOneTime = document.querySelector(
				".appstle_saving_badge_text_amount.onetime"
			);
			const savingBadgeSubscription = document.querySelector(
				".appstle_saving_badge_text_amount.subscription"
			);

			if (frequencyWrapper) {
				if (selectedRadio.value === "") {
					// One-time purchase selected
					frequencyWrapper.classList.remove("expanded");
					subscriptionWrapper.style.rowGap = "0px";
					subscriptionContent.classList.remove("expanded");
					benefitsWrapper.classList.remove("expanded");
					if (quantitySelector) quantitySelector.style.display = "block";
					productForm.querySelector("input[name='selling_plan']").value = "";
					if (savingBadgeOneTime) savingBadgeOneTime.style.display = "inline-block";
					if (savingBadgeSubscription) savingBadgeSubscription.style.display = "none";
					if (buttonPrice) updatePriceForQuantity();
				} else {
					// Subscription selected
					frequencyWrapper.classList.add("expanded");
					subscriptionWrapper.style.rowGap = "15px";
					subscriptionContent.classList.add("expanded");
					benefitsWrapper.classList.add("expanded");
					if (quantitySelector) quantitySelector.style.display = "none";
					productForm.querySelector("input[name='selling_plan']").value = selectedRadio.value;
					if (savingBadgeOneTime) savingBadgeOneTime.style.display = "none";
					if (savingBadgeSubscription) savingBadgeSubscription.style.display = "inline-block";
					if (buttonPrice) updatePriceForQuantity();
				}
			}
		}

		// Add click handlers to option wrappers
		optionWrappers.forEach((wrapper) => {
			wrapper.addEventListener("click", function () {
				const radio = this.querySelector('input[name="selling_plan"]');
				if (radio) {
					radio.checked = true;
					handleOptionSelection(this, radio);
				}
			});
		});

		// Add change handlers to radio buttons
		radioButtons.forEach((radio) => {
			radio.addEventListener("change", function () {
				if (this.checked) {
					const wrapper = this.closest(".appstle_option_wrapper");
					handleOptionSelection(wrapper, this);

					// Only update URL if this is a one-time purchase (empty value)
					// Frequency changes handle their own URL updates
					if (this.value === "") {
						updateUrlParameter("selling_plan", "");
					}
				}
			});
		});

		// Handle frequency selection and update URL
		frequencyRadios.forEach((radio) => {
			radio.addEventListener("change", function () {
				if (this.checked) {
					const planId = this.value;

					// Update hidden input and widget data
					if (hiddenInput) {
						hiddenInput.value = planId;
					}
					widget.setAttribute("data-selected-selling-plan", planId);

					// Update subscription radio button value WITHOUT triggering change event
					const subscriptionRadio = widget.querySelector(
						'.appstle_subscription_option input[name="selling_plan"]'
					);
					if (subscriptionRadio) {
						subscriptionRadio.value = planId;
						// Make sure subscription option is selected
						subscriptionRadio.checked = true;
						// Update the wrapper styling manually to avoid triggering change event
						const wrapper = subscriptionRadio.closest(".appstle_option_wrapper");
						handleOptionSelection(wrapper, subscriptionRadio);
					}

					// Update URL with selling_plan parameter - do this last
					updateUrlParameter("selling_plan", planId);
				}
			});
		});

		// Handle frequency option clicks
		const frequencyOptions = widget.querySelectorAll(".appstle_frequency_option");
		frequencyOptions.forEach((option) => {
			option.addEventListener("click", function () {
				const radio = this.querySelector(".appstle_frequency_radio");
				if (radio && !radio.checked) {
					radio.checked = true;
					radio.dispatchEvent(new Event("change"));
					// The change event handler will update the hidden input and URL
				}
			});
		});

		// Add event listener for quantity changes
		const quantityInput = document.querySelector(".qty.quantity__input");
		if (quantityInput) {
			quantityInput.addEventListener("change", updatePriceForQuantity);
		}

		// Auto-select selling plan from URL if it exists
		const urlSellingPlan = getUrlParameter("selling_plan");

		if (urlSellingPlan) {
			const targetFrequencyRadio = widget.querySelector(
				`.appstle_frequency_radio[value="${urlSellingPlan}"]`
			);
			if (targetFrequencyRadio) {
				targetFrequencyRadio.checked = true;
				targetFrequencyRadio.dispatchEvent(new Event("change"));

				// Also select the subscription option
				const subscriptionRadio = widget.querySelector(
					'.appstle_subscription_option input[name="selling_plan"]'
				);
				if (subscriptionRadio) {
					subscriptionRadio.checked = true;
					subscriptionRadio.value = urlSellingPlan;
					const wrapper = subscriptionRadio.closest(".appstle_option_wrapper");
					handleOptionSelection(wrapper, subscriptionRadio);
				}
			}
		} else {
			// Initialize with default selection if no URL parameter
			const checkedRadio = widget.querySelector('input[name="selling_plan"]:checked');
			if (checkedRadio) {
				const wrapper = checkedRadio.closest(".appstle_option_wrapper");
				handleOptionSelection(wrapper, checkedRadio);
			}
		}
	}

	window.initModernAppstleWidget = initModernAppstleWidget;

	document.addEventListener("DOMContentLoaded", initModernAppstleWidget);
})();
